module.exports = __webpack_public_path__ + "static/seoImage-cf31fd2452966e070847876a98e55f8b.jpg";